import React, { useState } from "react";
import Sidebar from "../components/Sidebar";
import api, { API_BASE } from "../api/client";

const isHttp = (v = "") => /^https?:\/\//i.test(v);

const ProductImageEnhancer = () => {
  const [productId, setProductId] = useState("");
  const [productSearch, setProductSearch] = useState("");
  const [productResults, setProductResults] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [suggestions, setSuggestions] = useState([]);

  const searchProducts = async () => {
    const q = productSearch.trim();
    if (!q) return setProductResults([]);
    const res = await api.get(`/products/search`, { params: { q, limit: 12 } });
    const rows = res.data?.data || [];
    setProductResults(Array.isArray(rows) ? rows : []);
  };

  const loadSuggestions = async () => {
    if (!productId) return;
    const res = await api.get(`/admin/products/${productId}/image-suggestions`);
    setSuggestions(res.data?.data || []);
  };

  const generate = async () => {
    if (!productId) return alert("Enter product ID");
    setLoading(true);
    try {
      await api.post(`/admin/products/${productId}/image-suggestions/generate`, { query });
      await loadSuggestions();
    } catch (e) {
      alert(e.response?.data?.error || "Failed to generate suggestions");
    } finally {
      setLoading(false);
    }
  };

  const review = async (suggestionId, action) => {
    await api.patch(`/admin/products/image-suggestions/${suggestionId}/review`, { action });
    await loadSuggestions();
  };

  const srcFor = (u) => isHttp(u) ? u : `${API_BASE}/uploads/products/${u}`;

  return (
    <div className="dashboard-layout">
      <Sidebar />
      <div className="dashboard-main">
        <div className="container" style={{ padding: 24 }}>
          <h1>Product Detail Enhancer</h1>
          <p>Generate candidate images, review, and approve the best match.</p>
          <div style={{ display: "grid", gridTemplateColumns: "1fr auto", gap: 8, marginBottom: 10 }}>
            <input
              className="form-input"
              placeholder="Search product by name/code"
              value={productSearch}
              onChange={(e) => setProductSearch(e.target.value)}
            />
            <button className="btn btn-secondary" onClick={searchProducts}>Search</button>
          </div>
          {productResults.length > 0 && (
            <div style={{ maxHeight: 220, overflowY: "auto", border: "1px solid #e5e7eb", borderRadius: 8, marginBottom: 14 }}>
              {productResults.map((p) => (
                <button
                  key={p.id}
                  className="btn"
                  style={{ width: "100%", textAlign: "left", borderBottom: "1px solid #f0f0f0", borderRadius: 0 }}
                  onClick={() => {
                    setSelectedProduct(p);
                    setProductId(String(p.id));
                    setProductSearch(p.name);
                    setProductResults([]);
                  }}
                >
                  <b>{p.name}</b> <span style={{ color: "#666" }}>({p.product_code || "no-code"})</span>
                </button>
              ))}
            </div>
          )}
          <div style={{ display: "grid", gridTemplateColumns: "180px 1fr auto auto", gap: 8, marginBottom: 16 }}>
            <input className="form-input" placeholder="Product ID" value={productId} onChange={(e) => setProductId(e.target.value)} />
            <input className="form-input" placeholder="Query override (optional)" value={query} onChange={(e) => setQuery(e.target.value)} />
            <button className="btn btn-secondary" onClick={loadSuggestions}>Load</button>
            <button className="btn btn-primary" disabled={loading} onClick={generate}>{loading ? "Searching..." : "Generate Suggestions"}</button>
          </div>
          {selectedProduct && (
            <p style={{ marginTop: -8, marginBottom: 14, color: "#334155" }}>
              Selected: <b>{selectedProduct.name}</b> (ID: {selectedProduct.id})
            </p>
          )}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(220px,1fr))", gap: 12 }}>
            {suggestions.map((s) => (
              <div key={s.id} style={{ border: "1px solid #ddd", borderRadius: 8, padding: 10 }}>
                <img src={srcFor(s.image_url)} alt="" style={{ width: "100%", height: 140, objectFit: "contain", background: "#f8f8f8" }} />
                <div style={{ fontSize: 12, marginTop: 8 }}>status: <b>{s.status}</b></div>
                <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
                  <button className="btn btn-primary btn-sm" onClick={() => review(s.id, "approved")}>Approve</button>
                  <button className="btn btn-secondary btn-sm" onClick={() => review(s.id, "rejected")}>Reject</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductImageEnhancer;
